export const COMING_TO_FOREGROUND = "app-lifecycle/COMING_TO_FOREGROUND";
export const APP_CAME_TO_FOREGROUND = "app-lifecycle/APP_CAME_TO_FOREGROUND";
export const GOING_TO_BACKGROUND = "app-lifecycle/GOING_TO_BACKGROUND";
export const APP_WENT_TO_BACKGROUND = "app-lifecycle/APP_WENT_TO_BACKGROUND";
export const PUSH_READY_FOR_SUBSCRIPTION = "app-lifecycle/PUSH_READY_FOR_SUBSCRIPTION";

type ComingToForegroundAction = {
    type: typeof COMING_TO_FOREGROUND;
};

type AppCameToForegroundAction = {
    type: typeof APP_CAME_TO_FOREGROUND;
    payload?: {
        synced?: boolean;
    };
};

type GoingToBackgroundAction = {
    type: typeof GOING_TO_BACKGROUND;
};

type AppWentToBackgroundAction = {
    type: typeof APP_WENT_TO_BACKGROUND;
};

type PushReadyForSubscriptionAction = {
    type: typeof PUSH_READY_FOR_SUBSCRIPTION;
};

export type PublicAppLifecycleAction =
    | ComingToForegroundAction
    | AppCameToForegroundAction
    | GoingToBackgroundAction
    | AppWentToBackgroundAction
    | PushReadyForSubscriptionAction;

export const comingToForeground = (): ComingToForegroundAction => ({
    type: COMING_TO_FOREGROUND,
});

export const appCameToForeground = (synced = true): AppCameToForegroundAction => ({
    type: APP_CAME_TO_FOREGROUND,
    payload: {synced},
});

export const goingToBackground = (): GoingToBackgroundAction => ({
    type: GOING_TO_BACKGROUND,
});

export const appWentToBackground = (): AppWentToBackgroundAction => ({
    type: APP_WENT_TO_BACKGROUND,
});

export const pushReadyForSubscription = (): PushReadyForSubscriptionAction => ({
    type: PUSH_READY_FOR_SUBSCRIPTION,
});
